import PATHS from '@/router/paths'

const columns = {
  [PATHS.DOCS.BASE]: [],
  [PATHS.DOCS.RELEASES]: [],
  [PATHS.DOCS.PRIVACY_POLICY]: [],
}

export default columns
